import { render, staticRenderFns } from "./otherBack.vue?vue&type=template&id=2ff1bdd7&scoped=true"
import script from "./otherBack.vue?vue&type=script&lang=js"
export * from "./otherBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1bdd7",
  null
  
)

export default component.exports